import React from 'react';
import {
    arrayOf,
    func,
    node,
    oneOfType,
    string,
    bool,
    oneOf,
} from 'prop-types';
import { noop } from 'lodash';
import cn from 'classnames';
import { Icon } from '@fiverr-private/fit';
import { l_check } from '@fiverr-private/icons';
import { COLORS, COLOR_CLASSES } from './constants';

import classes from './index.module.scss';

const FilterButton = ({
    children,
    selected,
    active,
    onClick = noop,
    className = '',
    withCheckIcon = true,
    color = COLORS.GREEN,
}) => (
    <div
        onClick={onClick}
        className={cn(className, classes.buttonWrapper, COLOR_CLASSES[color], {
            [classes.selected]: selected,
            [classes.active]: active,
        })}
    >
        {selected && withCheckIcon && (
            <Icon className={classes.icon}>{l_check}</Icon>
        )}
        {children}
    </div>
);

FilterButton.COLORS = COLORS;

FilterButton.propTypes = {
    children: oneOfType([arrayOf(node), node]),
    onClick: func,
    className: string,
    active: bool,
    selected: bool,
    withCheckIcon: bool,
    color: oneOf(COLORS),
};

export default FilterButton;
